export default __webpack_public_path__ + "static/media/pic22.dde259dc.jpg";